const getReferenceId = (value) => {
	if (!value) {
		return null;
	}

	if (typeof value === 'string' || typeof value === 'number') {
		return String(value);
	}

	// Mongoose ObjectId exposes `_id` as itself, so recurse only through document-like wrappers.
	if (value._id && value._id !== value) {
		return getReferenceId(value._id);
	}

	if (typeof value.id === 'string' || typeof value.id === 'number') {
		return String(value.id);
	}

	const stringValue = value.toString?.();
	return stringValue && stringValue !== '[object Object]' ? stringValue : null;
};

const isCommDeviceEligibleForMachineSetup = (commDevice, pointOfSale) => {
	const pointOfSaleId = getReferenceId(pointOfSale);
	if (!commDevice || !pointOfSaleId || commDevice.archived === true || commDevice.destroyed === true) {
		return false;
	}

	const assignedPointOfSaleId = getReferenceId(commDevice.pointOfSale);
	return !assignedPointOfSaleId || assignedPointOfSaleId === pointOfSaleId;
};

export default isCommDeviceEligibleForMachineSetup;
